import Enum from "./Enum";

export default Enum.create( {
	GLOBAL: "GLOBAL",
	TEAM: "TEAM",
	ONE_ON_ONE: "ONE_ON_ONE",
} );
